export default __webpack_public_path__ + "static/singapore1-f3daae708b54bb324624d2be316f2395.gif";